<template>
  <div>
    <div class="newQuestionsBackground md:py-12 dark:bg-purple-600">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle dark:text-white">
          Which of the following modes of communication are you open to? (select
          all that apply)
        </h2>
        <!-- Q5-1-->
        <div data-aos="fade-left" class="checkboxes">
          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[0] === idArr[0]
            "
          >
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              Phone Call
            </label>
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option1"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              Phone Call
            </label>
          </span>

          <!-- Q5-2-->

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[1] === idArr[1]
            "
          >
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              Text</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option2"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple"
              >Text</label
            >
          </span>

          <!-- Q5-3-->

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[2] === idArr[2]
            "
          >
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              Video Chat</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option3"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option3" class="dark:text-white dark:bg-hero-purple">
              Video Chat</label
            >
          </span>

          <!-- Q5-4-->

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[3] === idArr[3]
            "
          >
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              In Person</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option4"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option4" class="dark:text-white dark:bg-hero-purple">
              In Person</label
            >
          </span>

          <!-- Q5-5-->

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[4] === idArr[4]
            "
          >
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              Self-Directed Learning</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option5"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              Self-Directed Learning</label
            >
          </span>

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[5] === idArr[5]
            "
          >
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option5" class="dark:text-white dark:bg-hero-purple">
              App</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option6"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              App</label
            >
          </span>

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[6] === idArr[6]
            "
          >
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              Website</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option7"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option7" class="dark:text-white dark:bg-hero-purple">
              Website</label
            >
          </span>

          <!-- Q5-6-->

          <span
            v-if="
              $store.state.views.questionFive.checkedButtons[7] === idArr[7]
            "
          >
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
              checked
            />

            <label for="option6" class="dark:text-white dark:bg-hero-purple">
              Any of the above</label
            >
          </span>

          <span v-else>
            <input
              type="checkbox"
              id="option8"
              v-on:click="checkboxesChecked"
              name="impact[]"
            />

            <label for="option8" class="dark:text-white dark:bg-hero-purple">
              Any of the above</label
            >
          </span>
        </div>
      </div>
    </div>

    <div
      class="
        alignFooter
        dark:bg-hero-purple
        border-b border-gray-200
        dark:border-hero-purple
      "
    >
      <div class="footerContainer">
        <HelpDialog />

        <button v-on:click="nextQuestion" class="nextButtonQuestions">
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";
export default {
  data() {
    return {
      answerOptions: {
        0: "Phone",
        1: "Text",
        2: "Video",
        3: "Person",
        4: "Self",
        5: "App",
        6: "Website",
        7: ["Phone", "Video", "Text", "Person", "Self", "App", "Website"],
      },

      idArr: {
        0: "option1",
        1: "option2",
        2: "option3",
        3: "option4",
        4: "option5",
        5: "option6",
        6: "option7",
        7: "option8",
      },
      isActive: false,
      flag: true,
    };
  },

  components: { BackButton, HelpDialog },

  mounted: function () {
    this.scrollToTop();
    this.checkPreviousInput();
    this.track();
  },
  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step5" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },
    checkboxesChecked() {
      var checkboxes = document.getElementsByName("impact[]");
      var total = 0;
      var i;

      //check to see if none of the above is checked
      if (!this.flag) {
        checkboxes[7].checked = false;
        this.flag = true;
      }

      if (checkboxes[7].checked && this.flag) {
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false;
        }
        checkboxes[7].checked = true;
        this.flag = false;
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          total = total + 1;
        }
      }

      if (total === 0) {
        this.isActive = false;
        store.commit("setNextButtonDeactive", '["questionFive"]');
      } else {
        this.isActive = true;
      }
    },

    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];
      var i;

      var checkboxes = document.getElementsByName("impact[]");

      if (checkboxes[7].checked) {
        answerArray = this.answerOptions[7];
      } else {
        for (i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].checked) {
            answerArray.push(this.answerOptions[i]);
          }
        }
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          activeChecked[i] = checkboxes[i].id;
        } else {
          activeChecked[i] = "NULL";
        }
      }

      for (let i = 0; i < answerArray.length; i++) {
        const currentURL = new URL(location.href);
        const isDemo = currentURL.searchParams.get('demo') === 'true';

        if (!isDemo) {
            this.$gtag.event("q5-answer", {
            event_category: "answers",
            event_label: answerArray[i],
          });
        } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
      }

      var objectForPages = {
        index: '["questionFive"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionFive"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionFive"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionEight"]');
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    checkPreviousInput() {
      if (store.state.views.questionFive.checkedButtons[5] === this.idArr[5]) {
        this.flag = false;
      }
    },
  },
};
</script>
